'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { triggerWootricSurveyWhenAvailable } from '../utils/triggerWootricSurvey';
export default class TriggerWootricSurvey extends Component {
  componentDidMount() {
    if (this.props.enabled) {
      triggerWootricSurveyWhenAvailable();
    }
  }

  render() {
    return null;
  }

}
TriggerWootricSurvey.propTypes = {
  enabled: PropTypes.bool.isRequired
};